<template>
  <v-container class="mb-16" fluid style="max-width: 960px">
    <v-row>
      <v-col>
        <v-card :disabled="cakeStore.isDisabledOrder" rounded="xl">
          <v-stepper v-model="cakeStep" vertical rounded="xl" class="pa-3">
            <v-stepper-step
              :complete="cakeStep > 1"
              step="1"
              :editable="cakeStep > 1"
            >
              <StepperTitle
                :step="1"
                :icon="icons.mdiCakeVariant"
                title="Pasta"
                subtitle="Aşağıdan Pastanın tipini ve kişi sayısını seçiniz"
              />
            </v-stepper-step>

            <v-stepper-content step="1">
              <StepperContentCake />
            </v-stepper-content>

            <v-stepper-step
              step="2"
              :complete="cakeStep > 2"
              :editable="cakeStep > 2"
            >
              <StepperTitle
                :step="2"
                :icon="icons.mdiStore"
                title="Teslimat"
                subtitle="Pastanın Şube/Bayi gönderileceği tarih"
              />
            </v-stepper-step>

            <v-stepper-content step="2">
              <StepperContentDelivery v-if="isDelivery" />
            </v-stepper-content>

            <v-stepper-step
              step="3"
              :complete="cakeStep > 3"
              :editable="cakeStep > 3"
            >
              <StepperTitle
                :step="3"
                :icon="icons.mdiOrderBoolDescending"
                title="İçerik"
                subtitle="İstenilen bilgileri doldurun"
              />
            </v-stepper-step>

            <v-stepper-content step="3">
              <StepperContentContent v-if="isContent" />
            </v-stepper-content>

            <v-stepper-step step="4">
              <StepperTitle
                :icon="icons.mdiTextLong"
                title="Özet"
                subtitle="İstenilen bilgileri doldurun"
              />
            </v-stepper-step>

            <v-stepper-content step="4">
              <StepperContentSummary />
            </v-stepper-content>
          </v-stepper>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useCakeStore } from "@/stores/cake";
import { storeToRefs } from "pinia";

// Icon
import {
  mdiCakeVariant,
  mdiOrderBoolDescending,
  mdiStore,
  mdiReceiptText,
  mdiTextLong,
  mdiArrowLeft,
  mdiPencil,
} from "@mdi/js";

import { useRouter } from "@core/utils";
import StepperTitle from "./StepperTitle.vue";
import StepperContentCake from "./steps/cake/Index.vue";
import StepperContentContent from "./steps/content/Index.vue";
import StepperContentDelivery from "./steps/delivery/Index.vue";
import StepperContentSummary from "./steps/summary/Index.vue";
export default {
  components: {
    StepperTitle,
    StepperContentCake,
    StepperContentContent,
    StepperContentDelivery,

    StepperContentSummary,
  },
  setup() {
    const cakeStore = useCakeStore();

    const { route, router } = useRouter();

    const { cakeStep, isContentShow, isDeliveryShow, isSummaryShow } =
      storeToRefs(cakeStore);

    const isContent = computed(() => {
      // Order component bir sefer gösterildi ise
      if (isContentShow.value) return true;

      // Step durumuna göre gösterime bakıyoruz
      return cakeStep.value > 2 ? (true, (isContentShow.value = true)) : false;
    });

    const isDelivery = computed(() => {
      // Order component bir sefer gösterildi ise
      if (isDeliveryShow.value) return true;

      // Step durumuna göre gösterime bakıyoruz
      return cakeStep.value > 1 ? (true, (isDeliveryShow.value = true)) : false;
    });

    const isSummary = computed(() => {
      // Order component bir sefer gösterildi ise
      if (isSummaryShow.value) return true;

      // Step durumuna göre gösterime bakıyoruz
      return cakeStep.value > 4 ? (true, (isSummaryShow.value = true)) : false;
    });

    const editData = (item) => {
      // Customer
      cakeStore.data.customer.name = item.name;
      cakeStore.data.customer.surname = item.surname;
      cakeStore.data.customer.tel = item.tel;
      cakeStore.data.customer.email = item.email;

      // Order
      cakeStore.data.baskets = item.lines.map((el) => {
        return {
          uid: el.uid,
          qty: el.qty,
        };
      });

      // Delivery
      cakeStore.data.delivery.deliverydate = item.deliverydate;
      cakeStore.data.delivery.deliveryhour = item.deliveryhour;
      cakeStore.data.delivery.paymenttype = item.paymenttype;
      cakeStore.data.delivery.customer = item.customer;
      cakeStore.data.delivery.officename = item.officename;
      cakeStore.data.delivery.city = item.city;
      cakeStore.data.delivery.state = item.state;
      cakeStore.data.delivery.address = item.address;
      cakeStore.data.delivery.notes = item.notes;
      cakeStore.data.delivery.needinvoice = item.needinvoice;
      cakeStore.data.delivery.isdifferentinvoiceaddr =
        item.isdifferentinvoiceaddr;
    };

    const refno = ref("");
    const isEdit = ref(false);

    onMounted(() => {
      cakeStore.isChangePage = false;
      cakeStore.data = cakeStore.dataDefault;
      cakeStore.cakeStep = 1;
      if (route.value.params.item) {
        refno.value = route.value.params.item.refno;
        isEdit.value = true;
        editData(route.value.params.item);
      }
    });

    return {
      cakeStore,
      cakeStep,
      isContent,
      isDelivery,
      isSummary,
      isEdit,
      refno,

      icons: {
        mdiCakeVariant,
        mdiOrderBoolDescending,
        mdiStore,
        mdiReceiptText,
        mdiTextLong,
        mdiArrowLeft,
        mdiPencil,
      },
    };
  },
};
</script>
